import { ElementType } from "./schema";

// 只允许以下卡片类型在useChatStore中加载
export const AccessElementTypes = [
  ElementType.RECOMMEND_VIDEOS, 
  ElementType.LESSON_SUMMARY, 
  ElementType.SPELLING_DICTATION, 
  ElementType.QUESTION, 
  ElementType.QUESTION_V2, 
  ElementType.FLASH_CARD, 
  ElementType.TIMELINE, 
  ElementType.RECOMMEND_SHORTS, 
  ElementType.INTERACTIVE, 
  ElementType.HIGHLIGHT,
  ElementType.GRAMMAR_FILL_IN_BLANK, 
  ElementType.GRAMMAR_DRAG_AND_DROP,
  ElementType.KEY_PROPERTY,
  ElementType.EXAMPLE_QUESTION,
  ElementType.SPELLING_DICTATION_V2,
  ElementType.TIMELINE_SPARK,
];

// 需要用户交互才能继续的元素类型，用于在learn页面，卡片内满足一定条件之后，设置can_continue为true，即可让continue按钮可用
export const InteractiveElementTypes = [
  ElementType.QUESTION,
  ElementType.QUESTION_V2,
  ElementType.GRAMMAR_DRAG_AND_DROP,
  ElementType.GRAMMAR_FILL_IN_BLANK,
  ElementType.HIGHLIGHT,
  ElementType.FLASH_CARD,
  ElementType.SPELLING_DICTATION,
  ElementType.KEY_PROPERTY,
  ElementType.EXAMPLE_QUESTION,
];

// 用于控制卡片是否显示more detail按钮，或者explain按钮
export const QuizElementTypes = [
  ElementType.QUESTION,
  ElementType.QUESTION_V2,
  ElementType.GRAMMAR_FILL_IN_BLANK,
  ElementType.HIGHLIGHT,
  ElementType.SPELLING_DICTATION
];

// 以下几个element在卡片下方，不显示任何按钮
export const HideMoreDetailPosition = [
  ElementType.RECOMMEND_VIDEOS, 
  ElementType.RECOMMEND_SHORTS, 
  ElementType.INTERACTIVE,
  ElementType.EXAMPLE_QUESTION,
];

// 以下几个element作为question的element，需要校验是否回答正确
// 因为有些卡片只要点击了即可以得分，比如flashcard，所以需要将需要校验答案的element类型单独判断
export const QuestionElementTypes = [
  ElementType.QUESTION,
  ElementType.QUESTION_V2,
  ElementType.GRAMMAR_FILL_IN_BLANK,
  ElementType.GRAMMAR_DRAG_AND_DROP,
  ElementType.HIGHLIGHT,
  ElementType.EXAMPLE_QUESTION,
];